// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-warning-confirm-dialog .dialog-heading-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  font-size: 20px;
}
.fi-warning-confirm-dialog .dialog-heading-wrapper .mat-icon {
  margin-right: 10px;
  line-height: 24px;
  text-align: center;
  font-size: 20px;
  color: var(--fi-color-dialog-orange);
}
.fi-warning-confirm-dialog .warning-message {
  color: var(--fi-color-red);
  margin-bottom: 0;
}
.fi-warning-confirm-dialog .mat-mdc-form-field {
  margin-top: 25px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-dialogs-generic/warning-confirm/fi-warning-confirm-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAAR;AACQ;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AACZ;AAEI;EACI,0BAAA;EACA,gBAAA;AAAR;AAEI;EACI,gBAAA;EACA,WAAA;AAAR","sourcesContent":[".fi-warning-confirm-dialog {\r\n    .dialog-heading-wrapper {\r\n        display: flex;\r\n        align-items: center;\r\n        margin-bottom: 30px;\r\n        font-size: 20px;\r\n        .mat-icon {\r\n            margin-right: 10px;\r\n            line-height: 24px;\r\n            text-align: center;\r\n            font-size: 20px;\r\n            color: var(--fi-color-dialog-orange);\r\n        }\r\n    }\r\n    .warning-message {\r\n        color: var(--fi-color-red);\r\n        margin-bottom: 0;\r\n    }\r\n    .mat-mdc-form-field {\r\n        margin-top: 25px;\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
